import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as SpecialOffersActions from '../../actions';
import * as D from '../../deps';
import * as SpecialOffersSelectors from '../../selectors';

class IneligibleOfferModalButton extends React.Component {
  static propTypes = {
    specialOfferStatus: PropTypes.string,
    closeModal: PropTypes.func,
    logUpgradePageEvent: PropTypes.func,
    resetSpecialOffer: PropTypes.func,
  };

  closeIneligibleModal = () => {
    const { closeModal, logUpgradePageEvent, resetSpecialOffer } = this.props;
    closeModal();
    resetSpecialOffer();
    logUpgradePageEvent({
      action: D.PaymentsConstants.Analytics.SEE_MY_OFFERS_CLICKED,
      pageView: D.getInDomain('analytics.constants.StatsPageViewNames.PAYMENT'),
      viewMode: D.PaymentsUtils.getSpecialOfferErrorViewMode(this.props.specialOfferStatus),
    });
  };

  render() {
    return (
      <D.ButtonT3 onClick={this.closeIneligibleModal}>
        <FormattedMessage {...D.PaymentsConstants.Messages.seeOffer} />
      </D.ButtonT3>
    );
  }
}

export function mapStateToProps(state) {
  return {
    specialOfferStatus: SpecialOffersSelectors.getSpecialOfferStatus(state),
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      closeModal: D.Actions.Modal.closeModal,
      logUpgradePageEvent: D.PaymentsActions.logUpgradePageEvent,
      resetSpecialOffer: SpecialOffersActions.resetSpecialOffer,
    },
    dispatch,
  );
}

// We use injectIntl here because there was some inexplicable performance issues when using <FormattedMessage> directly in the props
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(IneligibleOfferModalButton));
